import clsx from 'clsx'
import { useState, useRef, useEffect, ReactNode } from 'react'
import $ from './styles.module.css'


export default function Dropdown({ trigger, children, open, onOpenChange, align, verticalAlign, class: className }: {
  trigger: ReactNode
  children: ReactNode
  open?: boolean
  onOpenChange?: (open: boolean) => void
  align?: 'left' | 'right'
  verticalAlign?: 'top' | 'bottom'
  class?: string
}) {
  let [internalOpen, setInternalOpen] = useState(false)
  let dropdownRef = useRef<HTMLDivElement>(null)

  let isOpen = open !== undefined ? open : internalOpen
  let setIsOpen = onOpenChange || setInternalOpen

  useEffect(() => {
    if (!isOpen) return

    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isOpen, setIsOpen])

  return (
    <div class={clsx($.dropdown, className)} ref={dropdownRef}>
      <div onClick={() => setIsOpen(!isOpen)}>
        {trigger}
      </div>
      {isOpen && (
        <div class={clsx($.content, align === 'right' && $.alignRight, verticalAlign === 'top' && $.alignTop)}>
          {children}
        </div>
      )}
    </div>
  )
}
